module.exports = __webpack_public_path__ + "static/img/product_society_society_hyyjs.316f1dc.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_hyyjs.svg
// module id = ifzp
// module chunks = 0